/* Angular Component */
import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "radio-collection",
  templateUrl: "./radioCollection.component.html",
  styleUrls: ["./radioCollection.component.scss"],
})
export class RadioCollectionComponent {
  @Input()
  options = [];

  @Input()
  key = "name";

  @Input()
  horizontal = false;

  @Output()
  output = new EventEmitter();

  selected;
  radioName = "";

  ngOnInit() {
    this.radioName = new Date().getTime() + "_RADIO";
  }

  /**
   * Select item
   * @param value
   * @param index
   */
  selectItem(value, index) {
    /* Walking.. */
    this.options.forEach(
      ((item, itemIndex) => {
        this.options[itemIndex]["selected"] = false;
      }).bind(this),
    );

    this.options[index]["selected"] = true;

    this.output.emit(this.options[index]);
  }
}
